<template>
  <span class="client-gold" :title="title">
    <Icon name="star" :size="size - 2" />
    <span v-if="!iconOnly">Client</span>
  </span>
</template>

<script setup lang="ts">
import Icon from './Icon.vue'

withDefaults(defineProps<{
  /** Taille de l'icône (px). */
  size?: number
  /** N'afficher que l'étoile (sans le mot « Client »). */
  iconOnly?: boolean
  title?: string
}>(), {
  size: 12,
  iconOnly: false,
  title: 'Client — exclu des appels automatiques (appelable manuellement)',
})
</script>

<style scoped>
.client-gold {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.04em;
  padding: 2px 8px; border-radius: 999px;
  background: linear-gradient(135deg, #FDE68A 0%, #F59E0B 100%);
  color: #6B3F05;
  box-shadow: 0 1px 3px rgba(217,119,6,0.35), inset 0 1px 0 rgba(255,255,255,0.55);
  white-space: nowrap;
  vertical-align: middle;
}
.client-gold :deep(svg) { color: #B45309; }
</style>
